<template>
    <div id="ioMeasurePanel" class="panel-group">
        <div id="intraoralMeasurePanel" ref="intraoralMeasurePanel" class="collapse list-group measure-panel ">
            <div class="measure-settings">
                <li class="list-group-item setting-item active">Settings</li>
                <li class="list-group-item setting-item">
                    <label class="setting-ctrl">
                        <span class="check-label">Show Teeth Lines</span>
                        <input type="checkbox" class="check-input" v-model="editContext.showTeethLines"
                            @change="setShowTeethLines($event)">
                    </label>

                    <label class="setting-ctrl">
                        <span class="check-label">Show Teeth Numbers</span>
                        <input type="checkbox" class="check-input" v-model="editContext.showTeethNumbers"
                            @change="setShowTeethNumbers($event)">
                    </label>

                    <label class="setting-ctrl">
                        <span class="check-label">Show Cross Lines</span>
                        <input type="checkbox" class="check-input" v-model="editContext.showCrossLines"
                            @change="setShowCrossLines($event)">
                    </label>
                </li>
                <li class="list-group-item setting-item active">Distances</li>
                <li class="list-group-item setting-item">
                    <label v-show="!!editContext.sumDistance" class="setting-ctrl">
                        <span class="check-label selectable">Sum Distance:
                            {{ editContext.sumDistance.toFixed(2) }} mm</span>
                    </label>
                    <label class="setting-ctrl">
                        <span class="check-label selectable">Total Distance: {{
                            editContext.totalDistance.toFixed(2) }} mm</span>
                    </label>
                    <label class="setting-ctrl">
                        <span class="check-label selectable">5 to 5 Distance: {{
                            editContext.premolarDistance.toFixed(2) }} mm</span>
                    </label>
                    <label class="setting-ctrl">
                        <span class="check-label selectable">3 to 3 Distance: {{
                            editContext.firstSixDistance.toFixed(2) }} mm</span>
                    </label>
                </li>
                <li v-show="commonContext.hasUpper && commonContext.hasLower"
                    class="list-group-item setting-item active">Bolton Analysis</li>
                <li v-show="commonContext.hasUpper && commonContext.hasLower" class="list-group-item setting-item">
                    <label class="analysis-ctrl">
                        <span class="analysis-label selectable"><b>3 to 3: </b></span>
                        <span class="analysis-label selectable">Lower distance = {{
                            commonContext.lowerTeethFirstSixSum.toFixed(2)
                        }} mm</span>
                        <span class="analysis-label selectable"> Upper distance = {{
                                commonContext.upperTeethFirstSixSum.toFixed(2) }} mm</span>
                        <span class="analysis-label selectable">Ratio = {{
                            firstSixRatio }} %</span>
                        <span class="analysis-label selectable"><b>{{ firstSixBolton }}</b></span>
                    </label>
                    <label class="setting-ctrl">
                        <span class="check-label"></span>
                    </label>
                    <label class="analysis-ctrl">
                        <span class="analysis-label selectable"><b>6 to 6: </b></span>
                        <span class="analysis-label selectable">Lower distance = {{
                            commonContext.lowerTeethTwelveSum.toFixed(2)
                        }} mm</span>
                        <span class="analysis-label selectable">Upper distance = {{
                                commonContext.upperTeethTwelveSum.toFixed(2) }} mm</span>
                        <span class="analysis-label selectable">Ratio = {{
                            firstTwelveRatio }} %</span>
                        <span class="analysis-label selectable"><b>{{
                            firstTwelveBolton }}</b></span>
                    </label>
                </li>
            </div>
            <div class="measure-list-bottom">
                <button type="button" class="btn btn-primary btn-sm btn-block cancel-btn"
                    v-on:click="exitMeasureMode(true)">Save
                    Measurements
                </button>

                <button type="button" class="btn btn-primary btn-sm btn-block cancel-btn"
                    v-on:click="exitMeasureMode(false)">Exit Module
                </button>

                <button type="button" class="btn btn-primary btn-sm btn-block cancel-btn" v-on:click="close">Hide Panel
                </button>
            </div>
        </div>
    </div>
</template>

<script>

import {
    switchShowTeethLines, switchShowCrossLines, switchShowTeethNumbers, leaveMeasureMode
} from "./IntraoralMeasureMode.js";

export default {
    name: "IntraoralMeasurePanel",
    props: ["commonContext", "editContext"],
    data() {
        return {
            visibilities: [
            ],
        }
    },
    methods: {
        close: function () {
            console.log("close intraoralMeasurePanel");
            $(`#intraoralMeasurePanel`).removeClass("show");
        },
        setShowTeethLines: function (event) {
            switchShowTeethLines(this.editContext.showTeethLines);
        },
        setShowTeethNumbers: function (event) {
            switchShowTeethNumbers(this.editContext.showTeethNumbers);
        },
        setShowCrossLines: function (event) {
            switchShowCrossLines(this.editContext.showCrossLines);
        },
        exitMeasureMode: function (saveChanges) {
            leaveMeasureMode(saveChanges);
        }
    },
    computed: {
        firstSixRatio: function () {
            return this.commonContext.getFirstSixRatioPercent(); //+ "%";
        },
        firstTwelveRatio: function () {
            return this.commonContext.getFirstTwelveRatioPercent(); // + "%";
        },
        firstSixBolton: function () {
            return this.commonContext.getFirstSixBoltonAnalysis();
        },
        firstTwelveBolton: function () {
            return this.commonContext.getFirstTwelveBoltonAnalysis();
        }
    },
}

</script>

<style scoped>
#ioMeasurePanel {
    display: none;
    position: absolute;
    top: 60px;
    right: 319px;
    z-index: 9;
    text-align: left;
    height: calc(100% - 107px);
    width: 0;
    font-family: Montserrat, sans-serif;
    font-size: small;
    background-color: red;
}

.btn {
    font-size: small;
}

.selectable {
    -moz-user-select: text;
    -webkit-user-select: text;
    -ms-user-select: text;
    user-select: text;
}

.setting-group {
    text-align: left;
    border: 1px solid #ced4da;
    align-items: end;
    border-radius: 0.2rem;
    padding-right: 5px;
}

.setting-ctrl {
    text-align: left;
    display: block;
    white-space: nowrap;
    margin: 0;
}

.analysis-ctrl {
    text-align: left;
    display: block;
    white-space: nowrap;
    margin: 0;
}

.check-label {
    margin-right: 0.5rem;
    vertical-align: middle;
}

.bold-label {
    margin-right: 0.5rem;
    vertical-align: middle;
    font-size: bold;
}

.analysis-label {
    margin-right: 0.5rem;
    display: block;
    /* Позволяет задавать ширину и корректно переносить строки */
    /* max-width: 100%; */
    /* Гарантирует, что span не выйдет за рамки родителя */
    white-space: normal;
    /* vertical-align: middle; */
}

.check-input {
    /* margin-top: 20px; */
    vertical-align: middle;
}

.measure-panel {
    /* border-radius: 0.25rem;  */
    position: absolute;
    width: 250px;
    /* right: -40px; */
    top: 30px;
    max-height: calc(100% - 40px);
    overflow-y: scroll;
    border-top-right-radius: 0.25rem;
    border-top-left-radius: 0.25rem;
    border-bottom-right-radius: 0.25rem;
    border-bottom-left-radius: 0.25rem;
    /* border: solid 1px white; */
}

.measure-settings {
    width: 100%;
    background: #77a7fd;
    border-top-right-radius: 0.25rem;
    border-top-left-radius: 0.25rem;
}

.setting-item {
    text-align: center;
    padding: .3rem .4rem;
    border-bottom-right-radius: 0;
    border-bottom-left-radius: 0;
}

.setting-btn {
    margin: 2px 0;
    padding: 0;
}

.measure-list {
    background: white;
    /* #77a7fd; */
    overflow-y: scroll;
    /* max-height: calc(100% - 120px); */
    width: 100%;
    /* calc(100% - 1px); */
    /* margin-left: 1px;
    margin-top: 1px; */
}

.measure-list-bottom {
    padding-bottom: 8px;
    background-color: white;
    width: 100%;
    border-bottom-right-radius: 0.25rem;
    border-bottom-left-radius: 0.25rem;
}

.apply-btn {
    margin: 0px 5px 0 5px;
    width: calc(100% - 10px);
}

.cancel-btn {
    margin: 8px 5px 0px 5px;
    width: calc(100% - 10px);
}

::-webkit-scrollbar {
    width: 5px;
}

::-webkit-scrollbar-track {
    box-shadow: inset 0 0 5px transparent;
    border-radius: 10px;
}

::-webkit-scrollbar-thumb {
    background: transparent;
    border-radius: 10px;
}

::-webkit-scrollbar-thumb:hover {
    background: #007bff;
}
</style>